/* src/app/home/imp-terms/imp-terms.component.scss */
/*# sourceMappingURL=imp-terms.component.css.map */
